import { withSvgIcon } from './withSvgIcon';

export const Globe = withSvgIcon(
  <>
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <ellipse
      cx="12"
      cy="12"
      rx="3"
      ry="9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M5 12L19 12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
